import React from "react";

const ExporterTabComponent = () => {
  return <div>ExporterTabComponent</div>;
};

export default ExporterTabComponent;
